module.exports = __webpack_public_path__ + "img/img-email-complete-m.png";